module.exports = __webpack_public_path__ + "img/pfizer.4274bbbe.jpg";